(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["purchase-box"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pbx').forEach(function (root) {
  var data = JSON.parse(root.querySelector('.pbx-data').textContent);
  var form = root.querySelector('.pbx-form');
  if (!form) return;
  var inputVariant = form.querySelector('.pbx-input-variant');
  var inputQty = form.querySelector('.pbx-input-qty');
  var inputPlan = form.querySelector('.pbx-input-plan');
  var defaultMode = root.getAttribute('data-pbx-default-mode') || 'onetime';
  var state = {
    variant: data.variants.find(function (v) { return String(v.id) === inputVariant.value; }) || data.variants[0],
    qty: 1,
    mode: defaultMode,
    plan: null,
    min: 1
  };
  var firstPlanRadio = form.querySelector('input[name="pbx-plan-radio"]:checked');
  if (firstPlanRadio) state.plan = firstPlanRadio.value;

  function currentMin() {
    if (state.mode !== 'sub' || !state.plan) return 1;
    var el = root.querySelector('.pbx-plan[data-pbx-plan="' + state.plan + '"]');
    var m = el ? parseInt(el.getAttribute('data-pbx-min'), 10) : 1;
    return isNaN(m) || m < 1 ? 1 : m;
  }
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function fmtDate(d) {
    return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.';
  }
  function unitNote(priceCents) {
    var v = state.variant;
    if (v.unit_price == null || !v.unit_label || !v.price) return '';
    var scaled = Math.round(v.unit_price * (priceCents / v.price));
    return money(scaled) + ' / ' + v.unit_label + ' · ';
  }
  function set(sel, val) {
    root.querySelectorAll(sel).forEach(function (el) { el.textContent = val; });
  }
  function render() {
    state.min = currentMin();
    if (state.qty < state.min) state.qty = state.min;

    set('[data-pbx="onetime-price"]', money(state.variant.price));
    set('[data-pbx="onetime-unit"]', unitNote(state.variant.price));
    root.querySelectorAll('.pbx-plan').forEach(function (planEl) {
      var pid = planEl.getAttribute('data-pbx-plan');
      var p = (state.variant.plans || {})[pid];
      var priceEl = planEl.querySelector('[data-pbx-plan-price]');
      var cmpEl = planEl.querySelector('[data-pbx-plan-compare]');
      var unitEl = planEl.querySelector('[data-pbx-plan-unit]');
      if (priceEl && p != null) priceEl.textContent = money(p);
      if (cmpEl) cmpEl.textContent = p != null && p < state.variant.price ? money(state.variant.price) : '';
      if (unitEl) unitEl.textContent = p != null ? unitNote(p) : '';
    });
    set('[data-pbx="qty"]', state.qty);
    root.querySelectorAll('.pbx-step[data-pbx-step="-1"]').forEach(function (b) {
      b.disabled = state.qty <= state.min;
    });
    inputQty.value = state.qty;
    inputVariant.value = state.variant.id;
    if (state.mode === 'sub' && state.plan) {
      inputPlan.value = state.plan;
      inputPlan.disabled = false;
    } else {
      inputPlan.value = '';
      inputPlan.disabled = true;
    }
    var d1 = new Date(); d1.setDate(d1.getDate() + 2);
    var d2 = new Date(); d2.setDate(d2.getDate() + 4);
    set('[data-pbx="delivery-date"]', fmtDate(d1) + ' – ' + fmtDate(d2) + d2.getFullYear());
  }

  form.querySelectorAll('input[name="pbx-size"]').forEach(function (r) {
    r.addEventListener('change', function () {
      state.variant = data.variants.find(function (v) { return String(v.id) === r.value; });
      render();
    });
  });
  form.querySelectorAll('input[name="pbx-mode"]').forEach(function (r) {
    r.addEventListener('change', function () {
      state.mode = r.value;
      if (r.value === 'onetime') state.qty = 1;
      root.querySelectorAll('.pbx-card').forEach(function (c) {
        c.classList.toggle('pbx-card--active', c.getAttribute('data-pbx-card') === r.value);
      });
      render();
    });
  });
  form.querySelectorAll('input[name="pbx-plan-radio"]').forEach(function (r) {
    r.addEventListener('change', function () {
      state.plan = r.value;
      state.qty = currentMin();
      root.querySelectorAll('.pbx-plan').forEach(function (p) {
        p.classList.toggle('pbx-plan--active', p.getAttribute('data-pbx-plan') === r.value);
      });
      render();
    });
  });
  form.querySelectorAll('.pbx-plan-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var subRadio = form.querySelector('input[name="pbx-mode"][value="sub"]');
      if (subRadio && !subRadio.checked) {
        subRadio.checked = true;
        subRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
  root.querySelectorAll('.pbx-step').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.getAttribute('data-pbx-step'), 10);
      state.qty = Math.min(99, Math.max(state.min, state.qty + step));
      render();
    });
  });
  render();
});
  } catch(e) { console.error(e); }
})();

})();
